import { Box, Button, Modal } from "@mui/material";
import { User, UserRoles } from "../../types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Input } from "../../hookFormComponents.tsx/Input";
import { api } from "../../api/api";

type Props = {
  modalConfig: { open: boolean; data: any };
  handleClose: () => void;
  fetcher: () => Promise<void>;
  setModalConfig: React.Dispatch<
    React.SetStateAction<
      | {
          data?: User;
          open: boolean;
        }
      | undefined
    >
  >;
};

function CreateModal({
  modalConfig,
  handleClose,
  setModalConfig,
  fetcher,
}: Props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "white",
    boxShadow: 24,
    borderRadius: "10px",
    p: 4,
  };

  const validationSchema1 = Yup.object({
    name: Yup.string().required("Required"),
    quantity: Yup.number().required("Required"),
    bookings_per_slot: Yup.number().required("Required"),
  });

  const validationSchema2 = Yup.object({
    name: Yup.string().required("Required"),
    quantity: Yup.number().required("Required"),
    bookings_per_slot: Yup.number().required("Required"),
  });

  const {
    formState: { errors },
    control,
    setValue,
    register,
    handleSubmit,
    getValues,
  } = useForm<
    Yup.InferType<typeof validationSchema1 | typeof validationSchema2>
  >({
    resolver: yupResolver(
      !modalConfig.data ? validationSchema1 : validationSchema2
    ),
    defaultValues: modalConfig.data
      ? {
          name: modalConfig.data.name,
          quantity: modalConfig.data.quantity,
          bookings_per_slot: modalConfig.data.bookings_per_slot,
        }
      : {},
  });

  console.log(errors);
  return (
    <Modal open={modalConfig.open} onClose={handleClose}>
      <Box sx={style}>
        <form
          noValidate
          onSubmit={handleSubmit((values) => {
            if (modalConfig.data) {
              api
                .post(`/spaces/${modalConfig.data.id}/update`, values)
                .then((res) => {
                  fetcher();
                  setModalConfig((prev) => ({
                    data: undefined,
                    open: false,
                  }));
                })
                .catch((e) => console.log(e));
            } else {
              api
                .post(`/spaces/create`, values)
                .then((res) => {
                  fetcher();
                  setModalConfig((prev) => ({
                    data: undefined,
                    open: false,
                  }));
                })
                .catch((e) => console.log(e));
            }
          })}
        >
          <Input
            required
            {...register("name")}
            label={"Name"}
            type="text"
            error={errors?.name?.message}
          />
          <Input
            required
            {...register("quantity")}
            label={"Quantity"}
            type="text"
            error={errors?.quantity?.message}
          />
          <Input
            required
            {...register("bookings_per_slot")}
            label={"Bookings per slot"}
            type="text"
            error={errors?.bookings_per_slot?.message}
          />
          <Box sx={{ display: "flex", justifyContent: "right" }}>
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
}

export default CreateModal;
